module.exports = __webpack_public_path__ + "static/calm-hand-d7b490d07233a3e08682371ffb158e43.mp4";